const INITIAL_VISIBLE = 10;

const grid = document.getElementById('stories-grid');
const revealButton = document.querySelector('[data-stories-reveal]');

if (grid && revealButton) {
    const stories = Array.from(grid.querySelectorAll('[data-story]'));

    revealButton.addEventListener('click', () => {
        const isExpanded = revealButton.getAttribute('aria-expanded') === 'true';

        stories.forEach((story, index) => {
            if (index >= INITIAL_VISIBLE) story.hidden = isExpanded;
        });

        revealButton.setAttribute('aria-expanded', String(!isExpanded));
        revealButton.textContent = isExpanded ? 'View All Stories' : 'Show Fewer Stories';
    });
}

document.querySelectorAll('.testimonial-modal.oi-video-modal').forEach((modal) => {
    modal.addEventListener('shown.bs.modal', () => {
        const iframe = modal.querySelector('iframe');
        if (!iframe) return;

        const entry = oi.loaded.video[iframe.id];

        if (entry && entry.is_mounted) {
            if (entry.player && typeof entry.player.is_playing === 'boolean') entry.play();
        } else {
            oi.video.mount(iframe);
        }
    });

    modal.addEventListener('hide.bs.modal', () => {
        const iframe = modal.querySelector('iframe');
        const entry = iframe && oi.loaded.video[iframe.id];
        if (entry && entry.player && typeof entry.player.is_playing === 'boolean') entry.pause();
    });
});
